export default "__VITE_ASSET__1dd8c5df__"